import { Component, HostBinding, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'nv-note',
  template: require('./nv-note.component.html'),
  styles: [require('./nv-note.component.scss')],
})
export class NvNoteComponent {
  /**
   *
   * A small note is inline—typically for one sentences
   *
   * A large note spans the full width—typically for more than on sentence
   */
  @Input() size: 'small' | 'large' = 'small';

  /**
   *
   */
  @Input() priority: 'info' | 'warning' | 'danger' = 'info';

  @HostBinding('class') classString = '';

  get iconName() {
    switch (this.priority) {
      case 'warning':
        return 'exclamation-yellow';
      case 'danger':
        return 'exclamation-red';
      default:
        return 'info';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.size || changes.priority) {
      this.classString = `${this.size} ${this.priority}`;
    }
  }
}
